export const FETCH_INDUSTRIES_SUCCESS = 'FETCH_INDUSTRIES_SUCCESS';
export const FETCH_INDUSTRIES_ERROR = 'FETCH_INDUSTRIES_ERROR';
export const DISMISS_INDUSTRY_BANNER = 'DISMISS_INDUSTRY_BANNER';
export const SET_SELECTED_HEALTH_SCORE_TYPE = 'SET_SELECTED_HEALTH_SCORE_TYPE';
export const SELECT_INDUSTRY_ERROR = 'SELECT_INDUSTRY_ERROR';